import React from 'react'
import { FormattedMessage } from 'react-intl'

import Link from '../Link'
import Preview from './Preview'

export default ({ items = [] }) => (
  <div>
    <div className='Home__news-grid'>
      {items.map(item => <Preview key={item._id} data={item} />)}
    </div>

    <div className='Home__more'>
      <Link to='/news' className='Button Button_black'>
        <FormattedMessage id='preview_list.see_all_news' />
      </Link>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/News/PreviewList.jsx